import React from 'react';
import DateTimeRangeContainer from './DateTimeRangeContainer'; // Local imported DateTimeRangeContainer
import { Moment } from 'moment';
import { Icon } from 'components/ui/icon';

interface IProps {
  start: Moment;
  end: Moment;
  applyCallback: (startDate: Moment, endDate: Moment) => void;
  ranges?: { [key: string]: Moment[] };
  local?: {
    format: string;
    sundayFirst?: boolean;
  };
  style?: Record<string, React.CSSProperties>;
  noMobileMode?: boolean;
  twelveHoursClock?: boolean;
  maxDate?: Moment;
  smartMode?: boolean;
  pastSearchFriendly?: boolean;
  children: React.ReactNode;
}

const DateTimePickerWrapper: React.FC<IProps> = ({
  start,
  end,
  applyCallback,
  ranges = {},
  local = { format: 'MM/DD/YYYY hh:mm A', sundayFirst: true },
  style = {},
  noMobileMode = false,
  twelveHoursClock = false,
  maxDate,
  smartMode = true,
  pastSearchFriendly = false,
  children,
}) => {
  return (
    <DateTimeRangeContainer
      start={start}
      end={end}
      applyCallback={applyCallback}
      ranges={ranges}
      local={local}
      style={style}
      noMobileMode={noMobileMode}
      twelveHoursClock={twelveHoursClock}
      maxDate={maxDate}
      smartMode={smartMode}
      pastSearchFriendly={pastSearchFriendly}
    >
      {children || (
        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
          <Icon name="calendar" size={16} style={{ marginRight: 8 }} />
          <div>
            {start.format(local.format)} - {end.format(local.format)}
          </div>
        </div>
      )}
    </DateTimeRangeContainer>
  );
};

export default DateTimePickerWrapper;
